import {
  getBusinessUserSaleLotsRoute,
  getSaleEntryRoute,
  getSaleyardAuctionRoute,
} from "lib/navigation";
import { useSelector } from "react-redux";
import { getIsBusinessUser, getIsSaleWatcher, getSaleById } from "selectors";

export const useGetCurrentSaleEntryRoute = (saleId: number) => {
  const isBusinessUser = useSelector(getIsBusinessUser);
  const isSaleWatcher = useSelector(getIsSaleWatcher);
  const currentSale = useSelector(getSaleById(saleId));

  if (currentSale) {
    const {
      saleyard_name: saleyardName,
      livestocksale_id: livestockSaleId,
      sale_type: saleType,
    } = currentSale;
    if (isBusinessUser) {
      return getBusinessUserSaleLotsRoute(saleyardName, livestockSaleId);
    }
    if (isSaleWatcher) {
      return `${getSaleyardAuctionRoute(saleyardName, livestockSaleId)}/watch`;
    }
    return getSaleEntryRoute(saleyardName, livestockSaleId, saleType);
  }
  return null;
};
